import styled from "styled-components";
import * as UIConstants from "../../UIConstants";

interface GraphButtonProps {
  isSelected: boolean;
}

export const HeaderWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
`;

export const BtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
  Button {
    height: 40px;
  }
`;

export const GraphWrapper = styled.div`
  width: 600px;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 20px 10px 20px 0;
  // display: flex;
  // flex-flow: column nowrap;
  // flex-basis: 40%;
  box-shadow: 0px 0px 2px rgb(0 0 0 / 12%);
  border-radius: 8px;
  ${UIConstants.customView} {
    width: 360px;
    // display: flex;
    // flex-flow: column nowrap;
    // flex-basis: 40%;
    padding: 15px 0 15px 0;
  }
`;

export const GraphList = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 50px;
`;

export const Card = styled.div`
  display: flex;
  // flex-flow:column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  flex-basis: 23%;
  /* max-width: 240px; */
`;

export const CardsList = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  margin-bottom: 50px;
  ${UIConstants.mobileView} {
    justify-content: center;
  }
`;

export const GraphButton = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: ${(props: GraphButtonProps) =>
    props.isSelected ? "#3a57e8" : "#000000"};
  background-color: ${(props: GraphButtonProps) =>
    props.isSelected ? "rgba(58,87,232,0.1)" : "#ffffff"};
  padding: 10px 8px;
  border: 1px solid #f1f1f1;
  text-align: left;
  cursor: pointer;
  // height: 60px;
  word-break: break-word;
`;

export const VerticalButton = styled.div`
  width: 150px;
  box-sizing: border-box;
  // display: flex;
  // flex-flow: column wrap;
  // align-items: flex-start;
  // justify-content: flex-start;
  margin-top: 30px;
  padding-right: 10px;
  ${UIConstants.mobileView} {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;

export const GraphRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 30px;
`;

export const GraphYaxis = styled.div`
  width: 250px;
  height: 50px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #f1f1f1;
  margin-left: 95px;
  margin-top: 15px;
  width: auto;
`;

export const GraphItem = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  // flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  ${UIConstants.mobileView} {
    flex-wrap: wrap;
  }
`;

export const Label = styled.div`
  background-color: rgba(58, 87, 232, 0.3);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
`;
export const GraphYButton = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 25px;
  cursor: pointer;
`;

export const BtnSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  text-align: right;
`;

export const RefreshBtn = styled.button`
  padding: 8px 16px;
  color: #ffffff;
  background-color: green;
  border: 1px solid green;
  cursor: pointer;
  border-radius: 4px;
`;
